export const DEFAULT_BACKGROUND_VARIANT = 'default';

export const APP_BACKGROUND_VARIANTS = {
  [DEFAULT_BACKGROUND_VARIANT]: {
    baseStops: [
      { offset: '0%', color: '#0b1226' },
      { offset: '42%', color: '#131f3b' },
      { offset: '100%', color: '#101a30' },
    ],
    glowLeftStops: [
      { offset: '0%', color: '#94c4ff', opacity: 0.34 },
      { offset: '58%', color: '#94c4ff', opacity: 0.16 },
      { offset: '100%', color: '#94c4ff', opacity: 0 },
    ],
    glowRightStops: [
      { offset: '0%', color: '#ff8ab8', opacity: 0.28 },
      { offset: '60%', color: '#ff8ab8', opacity: 0.12 },
      { offset: '100%', color: '#ff8ab8', opacity: 0 },
    ],
    horizonStops: [
      { offset: '0%', color: '#4ec5ff', opacity: 0.12 },
      { offset: '100%', color: '#4ec5ff', opacity: 0 },
    ],
  },
  twilight: {
    baseStops: [
      { offset: '0%', color: '#160b28' },
      { offset: '45%', color: '#311750' },
      { offset: '100%', color: '#0a0b1f' },
    ],
    glowLeftStops: [
      { offset: '0%', color: '#f782ff', opacity: 0.32 },
      { offset: '60%', color: '#f782ff', opacity: 0.14 },
      { offset: '100%', color: '#f782ff', opacity: 0 },
    ],
    glowRightStops: [
      { offset: '0%', color: '#ffb067', opacity: 0.28 },
      { offset: '65%', color: '#ffb067', opacity: 0.12 },
      { offset: '100%', color: '#ffb067', opacity: 0 },
    ],
    horizonStops: [
      { offset: '0%', color: '#7f5bff', opacity: 0.16 },
      { offset: '100%', color: '#7f5bff', opacity: 0 },
    ],
  },
  aurora: {
    baseStops: [
      { offset: '0%', color: '#031a2a' },
      { offset: '40%', color: '#092b3d' },
      { offset: '100%', color: '#04121f' },
    ],
    glowLeftStops: [
      { offset: '0%', color: '#3dffb8', opacity: 0.3 },
      { offset: '60%', color: '#3dffb8', opacity: 0.14 },
      { offset: '100%', color: '#3dffb8', opacity: 0 },
    ],
    glowRightStops: [
      { offset: '0%', color: '#4cb7ff', opacity: 0.26 },
      { offset: '60%', color: '#4cb7ff', opacity: 0.12 },
      { offset: '100%', color: '#4cb7ff', opacity: 0 },
    ],
    horizonStops: [
      { offset: '0%', color: '#43ffd1', opacity: 0.18 },
      { offset: '100%', color: '#43ffd1', opacity: 0 },
    ],
  },
  pulse: {
    baseStops: [
      { offset: '0%', color: '#020518' },
      { offset: '48%', color: '#06132f' },
      { offset: '100%', color: '#01030c' },
    ],
    glowLeftStops: [
      { offset: '0%', color: '#4fffdf', opacity: 0.32 },
      { offset: '55%', color: '#4fffdf', opacity: 0.15 },
      { offset: '100%', color: '#4fffdf', opacity: 0 },
    ],
    glowRightStops: [
      { offset: '0%', color: '#3d6dff', opacity: 0.38 },
      { offset: '62%', color: '#3d6dff', opacity: 0.16 },
      { offset: '100%', color: '#3d6dff', opacity: 0 },
    ],
    horizonStops: [
      { offset: '0%', color: '#00a0ff', opacity: 0.2 },
      { offset: '100%', color: '#00a0ff', opacity: 0 },
    ],
  },
  sunrise: {
    baseStops: [
      { offset: '0%', color: '#240910' },
      { offset: '46%', color: '#3a0f27' },
      { offset: '100%', color: '#120918' },
    ],
    glowLeftStops: [
      { offset: '0%', color: '#ff8aa6', opacity: 0.34 },
      { offset: '58%', color: '#ff8aa6', opacity: 0.16 },
      { offset: '100%', color: '#ff8aa6', opacity: 0 },
    ],
    glowRightStops: [
      { offset: '0%', color: '#ffd66b', opacity: 0.28 },
      { offset: '65%', color: '#ffd66b', opacity: 0.12 },
      { offset: '100%', color: '#ffd66b', opacity: 0 },
    ],
    horizonStops: [
      { offset: '0%', color: '#ffb27d', opacity: 0.17 },
      { offset: '100%', color: '#ffb27d', opacity: 0 },
    ],
  },
};

export const isValidBackgroundVariant = (variant) => (
  typeof variant === 'string' && Object.prototype.hasOwnProperty.call(APP_BACKGROUND_VARIANTS, variant)
);

export const normalizeBackgroundVariant = (variant) => (
  isValidBackgroundVariant(variant) ? variant : DEFAULT_BACKGROUND_VARIANT
);

export const backgroundVariantKeys = Object.freeze(Object.keys(APP_BACKGROUND_VARIANTS));
